<template>
	<div>
		<v-card class="shadowCard text--center">
			<v-img src="@/assets/backgrounds/beca_nivel.jpg"
				class="align-center"
			>
				<v-card-title>
					<v-spacer></v-spacer>
			  	<span class="text-h5 text--center white--text" align="center">Beca primer mes de inglés</span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-actions>
					<v-spacer></v-spacer>
					<a class="more-link text-caption" @click="dialogEncuesta = true">Contestar encuesta</a>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-img>
		</v-card>

		<v-dialog
      v-model="dialogEncuesta"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Beca de tu nivel de inglés
        </v-card-title>
        <v-card-text>

        	<br/>
        	<br/>
        	<!-- Pregunta #1 -->
        	<label><strong>¿La beca las vas a aprovechar tú o alguien más?</strong></label>
        	<v-radio-group v-model="persona_beca" row class="mb-4">
        	  <v-radio
			        label="Yo"
			        :value="1"
			      ></v-radio>
			      <v-radio
			        label="Alguien más"
			        :value="2"
			      ></v-radio>
        	</v-radio-group>		

        	<!-- Pregunta #2 -->
        	<label v-if="persona_beca && persona_beca == 2"><strong>Ingresa el nombre de la persona que tomará el curso</strong></label>
        	<v-text-field
        		v-if="persona_beca && persona_beca == 2"
        	  outlined
        	  dense
        	  v-model="nombre"
        	></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            dark
            rounded
            @click="dialogEncuesta = false"
          >
            Cerrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            rounded
            @click="enviarDatos()"
            v-if="persona_beca && persona_beca == 2 && nombre"
          >
            Guardar
          </v-btn>

          <v-btn
            color="primary"
            rounded
            @click="enviarDatos()"
            v-if="persona_beca && persona_beca == 1"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="dialogCopiarEnlace"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Examen de ubicación
        </v-card-title>
        <v-card-text>
        	<br/>
        	<br/>
        	<!-- Pregunta #1 -->
        	<label><strong>Excelente, por úlitmo, copia el siguiente enlace para poder presentar tu examen de ubicación y así asignarte un nivel de inglés y ubicarte en unos de nuestros grupos.</strong></label>
        </v-card-text>

        <v-card-actions>
	        <v-btn 
        		color="primary" 
        		dark 
        		block 
        		rounded 
            @click="copiarPortapapeles"
          >Presentar examen</v-btn>
        </v-card-actions>

        <v-btn 
	        @click="dialogCopiarEnlace = false, becaNivel.visible = false"
	        icon
	        absolute
	        top
	        right
	        class="mt-n3"
	      >
	        <v-icon>mdi-close</v-icon>
	      </v-btn>

      </v-card>
    </v-dialog>
	</div>
</template>
<script>
	// Importar lebrerías
	import { mapGetters, mapActions } from 'vuex'
	import { Clipboard } from '@capacitor/clipboard';
  // import { Share } from '@capacitor/share';


	export default {
		props:[
			'becaNivel'
	  ],

	  data: () => ({
	  	dialogEncuesta: false,
	  	persona_beca:null,
	  	nombre: null,
	  	dialogCopiarEnlace: false,
	  	show: false,
	  	mensajeTooltip: ''
	  }),

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{
      async enviarDatos( ){
      	const payload = {
      		id_alumno:        this.getUsuarioLMS.id,
      		persona_beca:     this.persona_beca ? this.persona_beca : 0,
      		nombre:           this.nombre ? this.nombre : '',
      	}

      	this.$http.post('encuestas.becanivel', payload ).then( response => {
      		this.dialogEncuesta     = false
      		this.dialogCopiarEnlace = true
        }).catch( error =>{
          this.validarError ( error )
        }).finally(()=>{ this.cargar = false })
      },


      async copiarPortapapeles( ){
      	window.open('https://fastenglish.com.mx/conoce-tu-nivel-de-ingles-ceaa/')
      }

    }
  }
</script>



<style scoped>
  /* Demo Stuff */
  a.more-link {
    background-color: rgba(255, 255, 255, 0.35);
    display: inline-block;
    padding: 12px 18px;
    color: #fff;
    text-decoration: none;
    font: 500 15px 'Work Sans', Helvetica, sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none !important;
    position: relative;
    border-radius: 30px;
    text-transform: uppercase;
    -webkit-transition: .1s all ease-in-out;
    -moz-transition: .1s all ease-in-out;
    -o-transition: .1s all ease-in-out;
    transition: .1s all ease-in-out;
  }
  a.more-link:hover {
    background-color: rgba(255, 255, 255, 0.50);
  }
  
  .link-container {
    text-align: center;
  }
  .link-container a.more-link {
    font-family: 'Source Sans Pro', Helvetica, sans-serif;
    background-color: #90b0bf;
    color: #fff;
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    line-height: 1.5;
    text-decoration: none;
    text-transform: none;
    font-weight: 400;
    letter-spacing: 1px;
  }


  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button:increment,.v-dialog__content.v-dialog__content--active::-webkit-scrollbar-button{
    display: none;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-dialog__content.v-dialog__content--active::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

</style>